"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCurrency = formatCurrency;

var _toUpper2 = _interopRequireDefault(require("lodash/toUpper"));

var _size2 = _interopRequireDefault(require("lodash/size"));

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _math = require("./math");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Get fraction digits.
 */
function getFractionDigits(decimalPlacesToDisplay, decimalPlaces) {
  var maximumDecimalPlaces = 8;
  var minimumFractionDigits = decimalPlacesToDisplay !== null && decimalPlacesToDisplay !== void 0 ? decimalPlacesToDisplay : decimalPlaces;

  if ((0, _isNil2["default"])(minimumFractionDigits)) {
    return maximumDecimalPlaces;
  } // $FlowFixMe


  return Math.min(minimumFractionDigits, maximumDecimalPlaces);
}
/**
 * Currency formatter.
 */


function currencyFormatter(options) {
  var assetCode = options.assetCode,
      decimalPlaces = options.decimalPlaces,
      decimalPlacesToDisplay = options.decimalPlacesToDisplay,
      locale = options.locale,
      skipTrailingZeros = options.skipTrailingZeros;
  var fractionDigits = getFractionDigits(decimalPlacesToDisplay, decimalPlaces);
  return new Intl.NumberFormat(locale, {
    currency: assetCode,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: skipTrailingZeros ? 0 : fractionDigits,
    style: 'currency'
  });
}
/**
 * Export `formatCurrency`.
 */


function formatCurrency(value, options) {
  var assetCode = options.assetCode,
      decimalPlaces = options.decimalPlaces,
      locale = options.locale,
      symbol = options.symbol;
  var roundedValue = (0, _math.roundUp)(value, decimalPlaces);

  try {
    return currencyFormatter(options).format(Number(roundedValue));
  } catch (e) {
    if (typeof Intl === 'undefined') {
      var currencySymbol = symbol !== null && symbol !== void 0 ? symbol : (0, _toUpper2["default"])(assetCode);
      var whitespace = (0, _size2["default"])(currencySymbol) > 1 ? ' ' : '';
      return "".concat(currencySymbol).concat(whitespace).concat(value);
    }

    var formatter = new Intl.NumberFormat(locale);
    var formattedValue = formatter.format(Number(value));

    if (!assetCode) {
      return formattedValue;
    }

    return "".concat(formattedValue).concat(symbol !== null && symbol !== void 0 ? symbol : (0, _toUpper2["default"])(assetCode));
  }
}